export default __webpack_public_path__ + "images/Schuetten-in-Displays.webp?4224a51929e9cc42f5a2a475e65b2940";